'use client';

import CDNImage from '@/components/ui/CDNImage';
import { Page_Pagebuilder_Blocks_Hero } from '@/graphql/generated/graphql';
import { m } from 'motion/react';
import {
  containerVariants,
  heroHeadingVariants,
  textVariants,
  viewPort,
} from 'utils/framer';
import { getContainerClass } from 'utils/helpers';
import Wysiwyg from '../components/dom-parser';

const HeroBlock = ({
  editor,
  editorPosition,
  containerWidth,
  image,
  imageMobile,
  video,
  videoMobile,
  videoHasControls,
}: Page_Pagebuilder_Blocks_Hero) => {
  const isTextInBottom = editorPosition === 'bottom';
  const isTextTop = editorPosition === 'top';
  return (
    <m.section
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      variants={containerVariants}
      className="hero relative w-full overflow-hidden"
    >
      <div className="relative grid h-full min-h-[85svh] lg:min-h-[800px]">
        <div className="absolute inset-0  z-[11]">
          {video && video.mediaItemUrl ? (
            <>
              <video
                autoPlay
                muted
                loop
                playsInline
                controls={videoHasControls}
                preload="metadata"
                className={`h-full w-full object-cover ${videoMobile && videoMobile.mediaItemUrl ? 'hidden lg:block' : 'block'}`}
              >
                <source src={video.mediaItemUrl} />
              </video>
              {videoMobile && videoMobile.mediaItemUrl ? (
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  controls={videoHasControls}
                  preload="metadata"
                  className="block h-full w-full object-cover lg:hidden"
                >
                  <source src={videoMobile.mediaItemUrl} />
                </video>
              ) : null}
            </>
          ) : image && image.sourceUrl ? (
            <>
              <CDNImage
                src={image.sourceUrl || ''}
                alt={image.altText || ''}
                width={image.mediaDetails.width || 0}
                height={image.mediaDetails.height || 0}
                sizes="(max-width: 1024px) 100vw, 100vw"
                srcSet={image.srcSet || ''}
                className={`h-full w-full object-cover ${imageMobile && imageMobile.sourceUrl ? 'hidden lg:block' : 'block'}`}
                loading="eager"
              />
              {imageMobile && imageMobile.sourceUrl ? (
                <CDNImage
                  src={imageMobile.sourceUrl || ''}
                  alt={imageMobile.altText || ''}
                  width={imageMobile.mediaDetails.width || 0}
                  height={imageMobile.mediaDetails.height || 0}
                  sizes="(max-width: 1024px) 100vw, 100vw"
                  srcSet={imageMobile.srcSet || ''}
                  className="block h-full w-full object-cover lg:hidden"
                  loading="eager"
                />
              ) : null}
            </>
          ) : (
            <div className="h-full w-full bg-neutral-900" />
          )}
          {(video || videoMobile) && (
            <div className="absolute inset-0 bg-black/35 -z-10" />
          )}
        </div>
        {editor && (
          <div
            className={`relative flex justify-center w-full h-full px-4 py-4 lg:py-16 z-[12] ${isTextInBottom ? 'items-end' : isTextTop ? 'items-start' : 'items-center'}`}
          >
            <div
              className={`mx-auto text-white ${getContainerClass(containerWidth)}`}
            >
              {editor && (
                <div className="editor editor-display">
                  <Wysiwyg
                    headingVariants={heroHeadingVariants}
                    variants={textVariants}
                    customViewport={{ once: false, margin: '0px' }}
                  >
                    {editor}
                  </Wysiwyg>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </m.section>
  );
};

export default HeroBlock;
